export const WORKSPACE_CONTINUOUS_SLIDER_THUMB_SIZE_PX = 28;

function clampRatio(value: number) {
  return Math.min(1, Math.max(0, value));
}

export function getWorkspaceContinuousSliderRatio(params: {
  value: number;
  min: number;
  max: number;
}) {
  const range = Math.max(Number.EPSILON, params.max - params.min);
  return clampRatio((params.value - params.min) / range);
}

export function getWorkspaceContinuousSliderThumbInset(params: {
  value: number;
  min: number;
  max: number;
}) {
  const ratio = getWorkspaceContinuousSliderRatio(params);
  const percentage = ratio * 100;
  const offsetPx = (0.5 - ratio) * WORKSPACE_CONTINUOUS_SLIDER_THUMB_SIZE_PX;

  return `calc(${percentage}% + ${offsetPx}px)`;
}

export function getWorkspaceContinuousSliderThumbCenterPx(params: {
  value: number;
  min: number;
  max: number;
  trackLeft: number;
  trackRight: number;
  rtl: boolean;
}) {
  const ratio = getWorkspaceContinuousSliderRatio(params);
  const halfThumb = WORKSPACE_CONTINUOUS_SLIDER_THUMB_SIZE_PX / 2;
  const usableWidth = Math.max(
    0,
    params.trackRight -
      params.trackLeft -
      WORKSPACE_CONTINUOUS_SLIDER_THUMB_SIZE_PX
  );

  return params.rtl
    ? params.trackRight - halfThumb - usableWidth * ratio
    : params.trackLeft + halfThumb + usableWidth * ratio;
}
